import React, { useState } from "react";

import {
  Message,
  isUserMessage,
  hasDashboardModification,
  getActionLabel,
  getMessageText,
} from "./messageUtils";

interface RevertedMessageGroupProps {
  messages: Message[];
}

export const RevertedMessageGroup: React.FC<RevertedMessageGroupProps> = ({ messages }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      {/* Header - always visible */}
      <button
        type="button"
        className="w-full flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={() => setIsExpanded(prev => !prev)}
      >
        <div className="flex items-center gap-2">
          <span className="material-icons text-gray-400" style={{ fontSize: 18 }}>
            auto_awesome
          </span>
          <span className="text-sm font-medium text-gray-500">Reverted change</span>
        </div>
        <span className="material-icons text-gray-400" style={{ fontSize: 20 }}>
          {isExpanded ? "expand_less" : "expand_more"}
        </span>
      </button>

      {/* Expanded content */}
      {isExpanded && (
        <div className="px-3 pb-3 flex flex-col gap-2">
          {messages.map(msg => {
            const isUser = isUserMessage(msg);
            const hasDashboardMod = hasDashboardModification(msg);
            const actionLabel = getActionLabel(msg);
            const messageText = getMessageText(msg);

            // User messages - muted gray box
            if (isUser) {
              return (
                <div
                  key={msg.id}
                  className="bg-gray-100 text-gray-500 text-left p-2 rounded-lg break-words text-sm"
                >
                  {messageText}
                </div>
              );
            }

            // Agent messages with dashboard modifications - show muted action label
            if (hasDashboardMod) {
              return (
                <div key={msg.id} className="flex items-center gap-2 px-2 py-1">
                  <span className="material-icons text-gray-400" style={{ fontSize: 16 }}>
                    auto_awesome
                  </span>
                  <span className="text-sm text-gray-500">{actionLabel}</span>
                </div>
              );
            }

            // Agent text messages - muted text
            if (messageText) {
              return (
                <div key={msg.id} className="text-sm text-gray-500 p-2">
                  {messageText}
                </div>
              );
            }

            return null;
          })}
        </div>
      )}
    </div>
  );
};
